
import React from 'react';
import { ReceiptsActions } from "../components/common/Actions/ReceiptsActions";
import { renderNamesString, renderNullFloatValues } from '../pages/index/Shared';
import TooltippedElement from '../components/common/TooltippedElement';
import FilterMultiSelect from "../components/table/FilterMultiSelect";
import { getStickyColumns } from '../helpers/table.jsx';
import StatusBadge from '../components/common/StatusBadge';
import { status_full_special as statusForBadge } from '../helpers/factdata';
import { arrayToLookup, arrayToLookupWithEmpty } from '../helpers/table';
import Select from 'react-select';
import useToast from "../hooks/useToast";
import api from '../api';

export const ReceiptsProjectTableColumns = (actualData, stratId, userCtx, actions, actionsParent, year, contragentCategories, onSetActualData) => {
  
  const addToast = useToast();

  const handleChooseCategory = async (value, id) => {
    const result = await api.post(`/mng/orgs/${id}`, {
        id: id,
        categoryId: value.value
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success('Категория успешно изменена'),
      onSetActualData(actualData.filter((e) => e.tableData.isTreeExpanded))
    )
  }

  const colsLeft = [
      {
          title: 'Действ.',
          render: (rowData) => 
            (<ReceiptsActions
              props={rowData}
              actions={rowData.hasOwnProperty('parentId') ? actions : actionsParent}
              userCtx={userCtx}
              stratId={stratId}
            />),
          width: '92px',
          editable: 'never',
      },
      {
          title: 'Статус',
          field: 'statusNew',
          editable: 'never',
          width: '176px',
          lookup: statusForBadge,
          render: ({ statusNew, comment }) => comment 
            ? <TooltippedElement tooltip={comment}><StatusBadge status={statusNew} type="receipts" /></TooltippedElement>
            : <StatusBadge status={statusNew} type="receipts" />
      },
      {
        title: 'Наименование темы',
        field: 'name',
        width: '217px',
        lookup: arrayToLookup('name', actualData),
        filterComponent: FilterMultiSelect,
        editable: 'never',
      },
  ];

  const colsMiddle = [
      {
        title: '№ темы',
        field: 'code',
        cellStyle: { minWidth: '152px'},
        lookup: arrayToLookup('code', actualData),
        filterComponent: FilterMultiSelect,
        editable: 'never',
      },
      {
        title: 'Руководитель темы',
        field: 'topicHeads',
        cellStyle: { minWidth: '40px'},
        render: (rowData) => renderNamesString(rowData.topicHeads),
        editable: 'never',
      },
      {
          title: 'Институт (где работает руководитель темы)',
          field: 'headsInstitute',
          cellStyle: { minWidth: '227px'},
          render: (rowData) => renderNamesString(rowData.headsInstitute),
          editable: 'never',
      },
      {
        title: 'Сумма лицевого счета/договора (всего), руб.',
        field: 'contractSum',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSum)),
        editable: 'never',
      },
      {
        title: 'Сумма договора, руб. (с учетом % уч.проекта)',
        field: 'contractSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSumWithShare)),
      },
      {
        title: `Сумма договора на ${year} год (всего), руб.`,
        field: 'contractYearSum',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        editable: 'never',
        render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSum)),
      },
      {
        title: `Сумма договора на ${year} год (с учетом % участия), руб.`,
        field: 'contractYearSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSumWithShare)),
      },
      {
        title: '% участия проекта в реализации договора',
        field: 'shareNew',
        cellStyle: { minWidth: '227px'},
        editable: 'never',
        render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.shareNew),
      },
      {
          title: '№ договора',
          field: 'num',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('num', actualData),
          filterComponent: FilterMultiSelect,
          render: (rowData) => !rowData.tableData.childRows && !rowData?.hasOwnProperty('parentId') ? 'Договоры появятся, когда будут движения денежных средств.' : rowData?.hasOwnProperty('parentId') ? rowData.num : '',
          editable: 'never',
      },
      {
          title: 'Дата начала договора',
          field: 'newRegDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newRegDate', actualData),
          filterComponent: FilterMultiSelect,
          editable: 'never',
      },
      {
          title: 'Дата окончания договора',
          field: 'newEndDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newEndDate', actualData),
          filterComponent: FilterMultiSelect,
          editable: 'never',
      },
      {
        title: 'Предмет договора',
        field: 'subject',
        cellStyle: { minWidth: '227px'},
        lookup: arrayToLookup('subject', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Вид деятельности',
        field: 'activityTypeName',
        cellStyle: { minWidth: '227px'},
        lookup: arrayToLookup('activityTypeName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
          title: 'Основной исполнитель договора',
          field: 'isPrimaryParticipantTitle',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('isPrimaryParticipantTitle', actualData),
          filterComponent: FilterMultiSelect,
          editable: 'never',
      },
      {
          title: 'Год поступления средств',
          field: 'year',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('year', actualData),
          filterComponent: FilterMultiSelect,
          editable: 'never',
      },
      {
          title: 'Тип',
          field: 'actualType',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('actualType', actualData),
          filterComponent: FilterMultiSelect,
          editable: 'never',
      },
      {
          title: 'Контрагент',
          field: 'contragentName',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('contragentName', actualData),
          filterComponent: FilterMultiSelect,
          editable: 'never',
      },
      {
          title: 'ИНН контрагента',
          field: 'contragentInn',
          cellStyle: { minWidth: '227px'},
          editable: 'never',
      },
      {
          title: 'Категория контрагента',
          field: 'contragentCategory',
          cellStyle: { minWidth: '227px' },
          filterCellStyle: { zIndex: 2 },
          render: (rowData) => (
            rowData.hasOwnProperty("parentId") && <Select
              placeholder="Выберите из списка категорию контрагента"
              options={contragentCategories}
              value={{value: rowData.contractOrg?.categoryId, label: rowData.contractOrg?.category}}
              onChange={(value) => handleChooseCategory(value, rowData.contractOrgId)}
            />
          ),
          lookup: arrayToLookup('contragentCategory', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Сумма поступлений по договору, руб.',
          field: 'paymentOrderSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSum)),
      },
      {
          title: 'Сумма поступлений по договору, руб. (с учетом % уч.проекта)',
          field: 'paymentOrderSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSumWithShare)),
      },
      {
          title: 'Реквизиты платежных поручений',
          field: 'paymentOrdersField',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
      },
      {
          title: 'Сумма актов, руб.',
          field: 'paymentActSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSum)),
      },
      {
          title: 'Сумма актов, руб. (с учетом % уч.проекта)',
          field: 'paymentActSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSumWithShare)),
      },
      {
          title: 'Реквизиты актов',
          field: 'paymentActsField',
          editable: 'never',
          filterCellStyle: { minWidth: '300px'},
          filtering: true,
      },
      {
          title: 'Сумма расходов по гранту, руб.',
          field: 'fbSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.fbSum)),
      },
      {
        title: 'Полученный результат',
        field: 'result',
        filtering: false,
        editable: 'never',
      },
    ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};

export const ProjectReceiptsColumns = (actualData, stratId, portfolioId, userCtx, actions, actionsParent, year, contragentCategories, onSetActualData) => {

  const addToast = useToast();

  const handleChooseCategory = async (value, id) => {
    const result = await api.post(`/mng/orgs/${id}`, {
        id: id,
        categoryId: value.value
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success('Категория успешно изменена'),
      onSetActualData(actualData.filter((e) => e.tableData.isTreeExpanded))
    )
  }

  const colsLeft = [
      {
          title: 'Действ.',
          render: (rowData) => (
              <ReceiptsActions
                  props={rowData}
                  actions={rowData.hasOwnProperty('parentId') ? actions : actionsParent}
                  userCtx={userCtx}
                  stratId={stratId}
                  portfId={portfolioId}
              />),
          width: '92px',
      },
      {
          title: 'Статус',
          field: 'statusNew',
          editable: 'never',
          width: '176px',
          lookup: statusForBadge,
          render: ({ statusNew, comment }) => comment 
            ? <TooltippedElement tooltip={comment}><StatusBadge status={statusNew} type="receipts" /></TooltippedElement>
            : <StatusBadge status={statusNew} type="receipts" />
      },
      {
        title: 'Наименование темы',
        field: 'name',
        width: '217px',
        lookup: arrayToLookup('name', actualData),
        filterComponent: FilterMultiSelect,
      },
  ];

  const colsMiddle = [
      {
        title: '№ темы',
        field: 'code',
        cellStyle: { minWidth: '152px'},
        lookup: arrayToLookup('code', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Руководитель темы',
        field: 'topicHeads',
        cellStyle: { minWidth: '40px'},
        render: (rowData) => renderNamesString(rowData.topicHeads),
      },
      {
          title: 'Институт (где работает руководитель темы)',
          field: 'headsInstitute',
          cellStyle: { minWidth: '227px'},
          render: (rowData) => renderNamesString(rowData.headsInstitute),
      },
      {
        title: 'Сумма лицевого счета/договора (всего), руб.',
        field: 'contractSum',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSum)),
      },
      {
        title: 'Сумма договора, руб. (с учетом % уч.проекта)',
        field: 'contractSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSumWithShare)),
      },
      {
        title: `Сумма договора на ${year} год (всего), руб.`,
        field: 'contractYearSum',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        editable: 'never',
        render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSum)),
      },
      {
        title: `Сумма договора на ${year} год (с учетом % участия), руб.`,
        field: 'contractYearSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSumWithShare)),
      },
      {
        title: '% участия проекта в реализации договора',
        field: 'shareNew',
        cellStyle: { minWidth: '227px'},
        render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.shareNew),
      },
      {
          title: '№ договора',
          field: 'num',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('num', actualData),
          filterComponent: FilterMultiSelect,
          render: (rowData) => !rowData.tableData.childRows && !rowData?.hasOwnProperty('parentId') ? 'Договоры появятся, когда будут движения денежных средств.' : rowData?.hasOwnProperty('parentId') ? rowData.num : '',
      },
      {
          title: 'Дата начала договора',
          field: 'newRegDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newRegDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Дата окончания договора',
          field: 'newEndDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newEndDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
        title: 'Предмет договора',
        field: 'subject',
        cellStyle: { minWidth: '227px'},
        lookup: arrayToLookup('subject', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Вид деятельности',
        field: 'activityTypeName',
        cellStyle: { minWidth: '227px'},
        lookup: arrayToLookup('activityTypeName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
          title: 'Основной исполнитель договора',
          field: 'isPrimaryParticipantTitle',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('isPrimaryParticipantTitle', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Год поступления средств',
          field: 'year',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('year', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Тип',
          field: 'actualType',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('actualType', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Контрагент',
          field: 'contragentName',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('contragentName', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'ИНН контрагента',
          field: 'contragentInn',
          cellStyle: { minWidth: '227px'},
      },
      {
          title: 'Категория контрагента',
          field: 'contragentCategory',
          cellStyle: { minWidth: '227px' },
          filterCellStyle: { zIndex: 2 },
          render: (rowData) => (
            rowData.hasOwnProperty("parentId") && <Select
              placeholder="Выберите из списка категорию контрагента"
              options={contragentCategories}
              value={{value: rowData.contractOrg?.categoryId, label: rowData.contractOrg?.category}}
              onChange={(value) => handleChooseCategory(value, rowData.contractOrgId)}
            />
          ),
          lookup: arrayToLookup('contragentCategory', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Сумма поступлений по договору, руб.',
          field: 'paymentOrderSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSum)),
      },
      {
          title: 'Сумма поступлений по договору, руб. (с учетом % уч.проекта)',
          field: 'paymentOrderSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSumWithShare)),
      },
      {
          title: 'Реквизиты платежных поручений',
          field: 'paymentOrdersField',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
      },
      {
          title: 'Сумма актов, руб.',
          field: 'paymentActSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSum)),
      },
      {
          title: 'Сумма актов, руб. (с учетом % уч.проекта)',
          field: 'paymentActSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSumWithShare)),
      },
      {
          title: 'Реквизиты актов',
          field: 'paymentActsField',
          editable: 'never',
          filterCellStyle: { minWidth: '300px'},
          filtering: true,
      },
      {
          title: 'Сумма расходов по гранту, руб.',
          field: 'fbSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.fbSum)),
      },
      {
        title: 'Полученный результат',
        field: 'result',
        filtering: false,
      },
    ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};

export const NioktrReceiptsTabColumns = (actualData, policyId, roleModel, userCtx, actions, actionsParent, year, contragentCategories, onSetActualData) => {

  const addToast = useToast();

  const handleChooseCategory = async (value, id) => {
    const result = await api.post(`/mng/orgs/${id}`, {
        id: id,
        categoryId: value.value
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success('Категория успешно изменена'),
      onSetActualData(actualData.filter((e) => e.tableData.isTreeExpanded))
    )
  }

  const colsLeft = [
    {
      title: 'Действ.',
      render: (rowData) => 
        (<ReceiptsActions
          props={rowData}
          actions={rowData.hasOwnProperty('parentId') ? actions : actionsParent}
          userCtx={userCtx}
          policyId={policyId}
          roleModel={roleModel}
          isInsideTabs
        />),
      width: '92px',
    },
    {
      title: 'Наименование темы',
      field: 'topic',
      width: '217px',
      render: (rowData) => rowData.topic,
      lookup: arrayToLookupWithEmpty('topic', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: '№ темы',
      field: 'code',
      width: '176px',
      lookup: arrayToLookup('code', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Руководитель темы',
      field: 'topicHeads',
      width: '230px',
      render: (rowData) => renderNamesString(rowData.topicHeads),
      lookup: arrayToLookupWithEmpty('topicHeads', actualData),
      filterComponent: FilterMultiSelect,
    },
  ];

  const colsMiddle = [
    {
      title: 'Институт (где работает руководитель темы)',
      field: 'headsInstitute',
      filterCellStyle: { minWidth: '227px'},
      render: (rowData) => renderNamesString(rowData.headsInstitute),
      lookup: arrayToLookupWithEmpty('headsInstitute', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Сумма лицевого счета/договора (всего, руб.)',
      field: 'contractSum',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.contractSum)),
    },
    {
      title: 'Сумма с учетом % участия, руб.',
      field: 'contractSumWithShare',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.contractSumWithShare)),
    },
    {
      title: `Сумма договора на ${year} год (всего), руб.`,
      field: 'contractYearSum',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      editable: 'never',
      render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSum)),
    },
    {
      title: `Сумма договора на ${year} год (с учетом % участия), руб.`,
      field: 'contractYearSumWithShare',
      editable: 'never',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSumWithShare)),
    },
    {
      title: '% участия в реализации договора',
      field: 'shareNew',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('shareNew', actualData),
      filterComponent: FilterMultiSelect,
      render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.shareNew),
    },
    {
      title: '№ договора',
      field: 'num',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('num', actualData),
      filterComponent: FilterMultiSelect,
      render: (rowData) => !rowData.tableData.childRows && !rowData?.hasOwnProperty('parentId') ? 'Договоры появятся, когда будут движения денежных средств.' : rowData?.hasOwnProperty('parentId') ? rowData.num : '',
    },
    {
      title: 'Дата начала договора',
      field: 'newRegDate',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('newRegDate', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Дата окончания договора',
      field: 'newEndDate',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('newEndDate', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Предмет договора',
      field: 'subject',
      cellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('subject', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Вид деятельности',
      field: 'activityTypeName',
      cellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('activityTypeName', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Основной исполнитель договора',
      field: 'isPrimaryParticipantTitle',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('isPrimaryPracticantTitle', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Год поступления средств',
      field: 'year',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('year', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Тип',
      field: 'actualType',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('type', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Контрагент',
      field: 'contragentName',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('contragentName', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'ИНН контрагента',
      field: 'contragentInn',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('contragentInn', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
        title: 'Категория контрагента',
        field: 'contragentCategory',
        cellStyle: { minWidth: '227px' },
        filterCellStyle: { zIndex: 2 },
        render: (rowData) => (
          rowData.hasOwnProperty("parentId") && <Select
            placeholder="Выберите из списка категорию контрагента"
            options={contragentCategories}
            value={{value: rowData.contractOrg?.categoryId, label: rowData.contractOrg?.category}}
            onChange={(value) => handleChooseCategory(value, rowData.contractOrgId)}
          />
        ),
        lookup: arrayToLookup('contragentCategory', actualData),
        filterComponent: FilterMultiSelect,
    },
    {
      title: 'Сумма поступлений, руб.',
      field: 'paymentOrderSum',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSum)),
    },
    {
      title: 'Сумма поступлений, руб. (с учетом % участия)',
      field: 'paymentOrderSumWithShare',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSumWithShare)),
    },
    {
      title: 'Реквизиты платежных поручений',
      field: 'paymentOrdersField',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('paymentOrdersField', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Сумма актов, руб.',
      field: 'paymentActSum',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSum)),
    },
    {
      title: 'Сумма актов, руб. (с учетом % уч.проекта)',
      field: 'paymentActSumWithShare',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSumWithShare)),
    },
    {
      title: 'Реквизиты актов',
      field: 'paymentActsField',
      filterCellStyle: { minWidth: '227px'},
      lookup: arrayToLookup('paymentActsField', actualData),
      filterComponent: FilterMultiSelect,
    },
    {
      title: 'Сумма расходов по гранту, руб.',
      field: 'fbSum',
      filterCellStyle: { minWidth: '227px'},
      filtering: true,
      render: (rowData) => renderNullFloatValues(Number(rowData.fbSum)),
    },
    {
      title: 'Полученный результат',
      field: 'result',
      filtering: false,
    },
    {
      title: 'Стратегический проект или раздел научно-исследовательской политики Программы развития университета, в рамках реализации которого (ых) поступили денежные средства',
      filterCellStyle: { minWidth: '500px'},
      filtering: false,
      render: (rowData) => rowData.strategy?.name || '-',
    },
  ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};

export const NioktrOwnFundsTabColumns = (actualData, policyId, roleModel, userCtx, actionsParent) => {

  const colsLeft = [
    {
      title: 'Действ.',
      render: (rowData) => 
        (<ReceiptsActions
          props={rowData}
          actions={actionsParent}
          userCtx={userCtx}
          policyId={policyId}
          roleModel={roleModel}
          isInsideTabs
        />),
      width: '92px',
    },
    {
      title: '№ п/п',
      field: 'num',
      width: '90px',
      render: (data) => 
        (<TableCell align='center' style={{ border: 'none' }}>
          {data.num}
        </TableCell>),
    },
    {
      title: 'Вид доходов',
      field: 'type',
      lookup: arrayToLookup('type', actualData),
      filterCellStyle: { width: '176px' },
      filterComponent: FilterMultiSelect,
      width: '176px',
      maxWidth: '176px',
    },
    {
      title: 'Реквизиты первичных документов, подтверждающие получение доходов',
      field: 'docNum',
      filterCellStyle: { minWidth: '190px', maxWidth: '190px'},
      filtering: true,
      width: '190px',
      maxWidth: '190px',
    }
  ];

  const colsMiddle = [
    {
      title: 'Краткая характеристика доходов',
      field: 'descr',
      filterCellStyle: { minWidth: '176px', maxWidth: '176px'},
      filtering: true,
      width: '176px',
    },
    {
      title: 'Сумма доходов, направленная на мероприятия Программы развития, руб.',
      field: 'sum',
      filterCellStyle: { minWidth: '280px', maxWidth: '280px'},
      filtering: true,
      width: '280px',
      render: (data) => renderNullFloatValues(Number(data.sum)),
    },
    {
      title: 'Наименование документа, подтверждающего выплату денежных средств',
      field: 'docNameNum',
      lookup: arrayToLookup('docNameNum', actualData),
      filterCellStyle: { minWidth: '176px', maxWidth: '176px'},
      filterComponent: FilterMultiSelect,
      width: '176px',
    },
    {
      title: '№, дата документа, подтверждающего выплату денежных средств',
      field: 'date',
      lookup: arrayToLookup('date', actualData),
      filterCellStyle: { minWidth: '165px', maxWidth: '165px'},
      filterComponent: FilterMultiSelect,
      width: '165px',
    },
    {
      title: 'Статья расходов',
      field: 'costItem',
      lookup: arrayToLookup('costItem', actualData),
      filterCellStyle: { minWidth: '176px', maxWidth: '176px'},
      filterComponent: FilterMultiSelect,
      width: '176px',
    },
    {
      title: 'Сумма выплат (всего), руб.',
      field: 'incomesSum',
      filterCellStyle: { minWidth: '185px', maxWidth: '185px'},
      filtering: true,
      width: '185px',
      render: (data) => renderNullFloatValues(Number(data.incomesSum)),
    },
    {
      title: 'Сумма за счет собственных средств, направленных на проведение прикладных научных исследований и (или) экспериментальных разработок, руб.',
      field: 'internalFundSum',
      filterCellStyle: { minWidth: '330px', maxWidth: '330px'},
      filtering: true,
      width: '330px',
      render: (data) => renderNullFloatValues(Number(data.internalFundSum)),
    },
    {
      title: 'Примечание',
      field: 'comment',
      filterCellStyle: { minWidth: '185px', maxWidth: '185px'},
      filtering: true,
      width: '185px',
      render: (data) => {
        if (data.comment.endsWith(',\n')) {
          return data.comment.slice(0, data.comment.length - 2);
        }
        return data.comment;
      },
    },
    {
      title: 'Стратегический проект или раздел научно-исследовательской политики Программы развития университета, в рамках реализации которого (ых) поступили денежные средства',
      field: 'policy',
      filterCellStyle: { minWidth: '330px'},
      filtering: false,
      width: '330px',
    },
  ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};

export const ReceiptsSPTableColumns = (actualData) => {

  const colsLeft = [
      {
          title: 'Статус',
          field: 'status',
          editable: 'never',
          width: '176px',
          lookup: statusForBadge,
          render: ({ status, comment }) => comment 
            ? <TooltippedElement tooltip={comment}><StatusBadge status={status} type="receipts" /></TooltippedElement>
            : <StatusBadge status={status} type="receipts" />
      },
      {
        title: '№ и название проекта',
        field: 'projName',
        width: '230px',
        lookup: arrayToLookup('projName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Наименование темы',
        field: 'name',
        width: '217px',
        lookup: arrayToLookup('name', actualData),
        filterComponent: FilterMultiSelect,
      },
  ];

  const colsMiddle = [
      {
        title: 'Руководитель проекта',
        field: 'headName',
        cellStyle: { minWidth: '40px'},
        lookup: arrayToLookup('headName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: '№ темы',
        field: 'code',
        cellStyle: { minWidth: '152px'},
        lookup: arrayToLookup('code', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Руководитель темы',
        field: 'topicHeads',
        cellStyle: { minWidth: '40px'},
        render: (rowData) => renderNamesString(rowData.topicHeads),
      },
      {
          title: 'Институт (где работает руководитель темы)',
          field: 'headsInstitute',
          cellStyle: { minWidth: '227px'},
          render: (rowData) => renderNamesString(rowData.headsInstitute),
      },
      {
        title: 'Сумма лицевого счета/договора (всего), руб.',
        field: 'contractSum',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSum)),
      },
      {
        title: 'Сумма договора, руб. (с учетом % уч.проекта)',
        field: 'contractSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSumWithShare)),
      },
      {
        title: '% участия проекта в реализации договора',
        field: 'shareNew',
        cellStyle: { minWidth: '227px'},
        render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.shareNew),
      },
      {
          title: '№ договора',
          field: 'num',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('num', actualData),
          filterComponent: FilterMultiSelect,
          render: (rowData) => !rowData.tableData.childRows && !rowData?.hasOwnProperty('parentId') ? 'Договоры появятся, когда будут движения денежных средств.' : rowData?.hasOwnProperty('parentId') ? rowData.num : '',
      },
      {
          title: 'Дата начала договора',
          field: 'newRegDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newRegDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Дата окончания договора',
          field: 'newEndDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newEndDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Основной исполнитель договора',
          field: 'isPrimaryParticipantTitle',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('isPrimaryParticipantTitle', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Год поступления средств',
          field: 'year',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('year', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Тип',
          field: 'actualType',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('actualType', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Контрагент',
          field: 'contragentName',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('contragentName', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'ИНН контрагента',
          field: 'contragentInn',
          cellStyle: { minWidth: '227px'},
      },
      {
          title: 'Сумма поступлений по договору, руб.',
          field: 'paymentOrderSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSum)),
      },
      {
          title: 'Сумма поступлений по договору, руб. (с учетом % уч.проекта)',
          field: 'paymentOrderSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSumWithShare)),
      },
      {
          title: 'Реквизиты платежных поручений',
          field: 'paymentOrdersField',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
      },
      {
          title: 'Сумма актов, руб.',
          field: 'paymentActSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSum)),
      },
      {
          title: 'Сумма актов, руб. (с учетом % уч.проекта)',
          field: 'paymentActSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSumWithShare)),
      },
      {
          title: 'Реквизиты актов',
          field: 'paymentActsField',
          editable: 'never',
          filterCellStyle: { minWidth: '300px'},
          filtering: true,
      },
      {
          title: 'Сумма расходов по гранту, руб.',
          field: 'fbSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.fbSum)),
      },
      {
          title: 'Портфель',
          field: 'portfName',
          cellStyle: { minWidth: '230px'},
          lookup: arrayToLookup('portfName', actualData),
          filterComponent: FilterMultiSelect,
      },
    ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};

export const ReceiptsPortfTableColumns = (actualData) => {
  const colsLeft = [
      {
          title: 'Статус',
          field: 'status',
          editable: 'never',
          width: '176px',
          lookup: statusForBadge,
          render: ({ status, comment }) => comment 
            ? <TooltippedElement tooltip={comment}><StatusBadge status={status} type="receipts" /></TooltippedElement>
            : <StatusBadge status={status} type="receipts" />
      },
      {
        title: '№ и название проекта',
        field: 'projName',
        width: '230px',
        lookup: arrayToLookup('projName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Наименование темы',
        field: 'name',
        width: '217px',
        lookup: arrayToLookup('name', actualData),
        filterComponent: FilterMultiSelect,
      },
  ];

  const colsMiddle = [
      {
        title: 'Руководитель проекта',
        field: 'headName',
        cellStyle: { minWidth: '40px'},
        lookup: arrayToLookup('headName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: '№ темы',
        field: 'code',
        cellStyle: { minWidth: '152px'},
        lookup: arrayToLookup('code', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Руководитель темы',
        field: 'topicHeads',
        cellStyle: { minWidth: '40px'},
        render: (rowData) => renderNamesString(rowData.topicHeads),
      },
      {
          title: 'Институт (где работает руководитель темы)',
          field: 'headsInstitute',
          cellStyle: { minWidth: '227px'},
          render: (rowData) => renderNamesString(rowData.headsInstitute),
      },
      {
        title: 'Сумма лицевого счета/договора (всего), руб.',
        field: 'contractSum',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSum)),
      },
      {
        title: 'Сумма договора, руб. (с учетом % уч.проекта)',
        field: 'contractSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSumWithShare)),
      },
      {
        title: '% участия проекта в реализации договора',
        field: 'shareNew',
        cellStyle: { minWidth: '227px'},
        render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.shareNew),
      },
      {
          title: '№ договора',
          field: 'num',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('num', actualData),
          filterComponent: FilterMultiSelect,
          render: (rowData) => !rowData.tableData.childRows && !rowData?.hasOwnProperty('parentId') ? 'Договоры появятся, когда будут движения денежных средств.' : rowData?.hasOwnProperty('parentId') ? rowData.num : '',
      },
      {
          title: 'Дата начала договора',
          field: 'newRegDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newRegDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Дата окончания договора',
          field: 'newEndDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newEndDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
        title: 'Вид деятельности',
        field: 'activityTypeName',
        cellStyle: { minWidth: '227px'},
        lookup: arrayToLookup('activityTypeName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
          title: 'Основной исполнитель договора',
          field: 'isPrimaryParticipantTitle',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('isPrimaryParticipantTitle', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Год поступления средств',
          field: 'year',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('year', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Тип',
          field: 'actualType',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('actualType', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Контрагент',
          field: 'contragentName',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('contragentName', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'ИНН контрагента',
          field: 'contragentInn',
          cellStyle: { minWidth: '227px'},
      },
      {
          title: 'Сумма поступлений по договору, руб.',
          field: 'paymentOrderSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSum)),
      },
      {
          title: 'Сумма поступлений по договору, руб. (с учетом % уч.проекта)',
          field: 'paymentOrderSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSumWithShare)),
      },
      {
          title: 'Реквизиты платежных поручений',
          field: 'paymentOrdersField',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
      },
      {
          title: 'Сумма актов, руб.',
          field: 'paymentActSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSum)),
      },
      {
          title: 'Сумма актов, руб. (с учетом % уч.проекта)',
          field: 'paymentActSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSumWithShare)),
      },
      {
          title: 'Реквизиты актов',
          field: 'paymentActsField',
          editable: 'never',
          filterCellStyle: { minWidth: '300px'},
          filtering: true,
      },
      {
          title: 'Сумма расходов по гранту, руб.',
          field: 'fbSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.fbSum)),
      },
    ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};

export const PartReceiptTableColumns = (actualData, userCtx, actions, year, contragentCategories, onSetActualData) => {

  const addToast = useToast();

  const handleChooseCategory = async (value, id) => {
    const result = await api.post(`/mng/orgs/${id}`, {
        id: id,
        categoryId: value.value
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success('Категория успешно изменена'),
      onSetActualData(actualData.filter((e) => e.tableData.isTreeExpanded))
    )
  }

  const colsLeft = [
      {
        title: 'Действ.',
        render: (rowData) => 
          (rowData.parentId ? <ReceiptsActions
            props={rowData}
            actions={actions}
            userCtx={userCtx}
            isProgram
            />
          : null),
        width: '92px',
      },
      {
        title: 'Статус',
        field: 'statusNew',
        editable: 'never',
        width: '130px',
        lookup: statusForBadge,
        render: ({ statusNew, comment }) => comment 
            ? <TooltippedElement tooltip={comment}><StatusBadge status={statusNew} type="receipts" /></TooltippedElement>
            : <StatusBadge status={statusNew} type="receipts" />
      },
      {
        title: 'Стратегический проект',
        field: 'stratName',
        width: '188px',
        lookup: arrayToLookup('stratName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: '№ и название проекта',
        field: 'projName',
        width: '230px',
        
        lookup: arrayToLookup('projName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Наименование темы',
        field: 'name',
        width: '217px',
        lookup: arrayToLookup('name', actualData),
        filterComponent: FilterMultiSelect,
      },
  ];

  const colsMiddle = [
      {
        title: 'Руководитель проекта',
        field: 'headName',
        cellStyle: { minWidth: '40px'},
        lookup: arrayToLookup('headName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: '№ темы',
        field: 'code',
        cellStyle: { minWidth: '152px'},
        lookup: arrayToLookup('code', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Руководитель темы',
        field: 'topicHeads',
        cellStyle: { minWidth: '40px'},
        render: (rowData) => renderNamesString(rowData.topicHeads),
      },
      {
          title: 'Институт (где работает руководитель темы)',
          field: 'headsInstitute',
          cellStyle: { minWidth: '227px'},
          render: (rowData) => renderNamesString(rowData.headsInstitute),
      },
      {
        title: 'Сумма лицевого счета/договора (всего), руб.',
        field: 'contractSum',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSum)),
      },
      {
        title: 'Сумма договора, руб. (с учетом % уч.проекта)',
        field: 'contractSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractSumWithShare)),
      },
      {
        title: `Сумма договора на ${year} год (всего), руб.`,
        field: 'contractYearSum',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        editable: 'never',
        render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSum)),
      },
      {
        title: `Сумма договора на ${year} год (с учетом % участия), руб.`,
        field: 'contractYearSumWithShare',
        editable: 'never',
        filterCellStyle: { minWidth: '227px'},
        filtering: true,
        render: (rowData) => renderNullFloatValues(Number(rowData.contractYearSumWithShare)),
      },
      {
        title: '% участия проекта в реализации договора',
        field: 'shareNew',
        cellStyle: { minWidth: '227px'},
        render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.shareNew),
      },
      {
          title: '№ договора',
          field: 'num',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('num', actualData),
          filterComponent: FilterMultiSelect,
          render: (rowData) => !rowData.tableData.childRows && !rowData?.hasOwnProperty('parentId') ? 'Договоры появятся, когда будут движения денежных средств.' : rowData?.hasOwnProperty('parentId') ? rowData.num : '',
      },
      {
          title: 'Дата начала договора',
          field: 'newRegDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newRegDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Дата окончания договора',
          field: 'newEndDate',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('newEndDate', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
        title: 'Предмет договора',
        field: 'subject',
        cellStyle: { minWidth: '227px'},
        lookup: arrayToLookup('subject', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
        title: 'Вид деятельности',
        field: 'activityTypeName',
        cellStyle: { minWidth: '227px'},
        lookup: arrayToLookup('activityTypeName', actualData),
        filterComponent: FilterMultiSelect,
      },
      {
          title: 'Основной исполнитель договора',
          field: 'isPrimaryParticipantTitle',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('isPrimaryParticipantTitle', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Год поступления средств',
          field: 'year',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('year', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Тип',
          field: 'actualType',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('actualType', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Контрагент',
          field: 'contragentName',
          cellStyle: { minWidth: '227px'},
          lookup: arrayToLookup('contragentName', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'ИНН контрагента',
          field: 'contragentInn',
          cellStyle: { minWidth: '227px'},
      },
      {
          title: 'Категория контрагента',
          field: 'contragentCategory',
          cellStyle: { minWidth: '227px' },
          filterCellStyle: { zIndex: 2 },
          render: (rowData) => (
            rowData.hasOwnProperty("parentId") && <Select
              placeholder="Выберите из списка категорию контрагента"
              options={contragentCategories}
              value={{value: rowData.contractOrg?.categoryId, label: rowData.contractOrg?.category}}
              onChange={(value) => handleChooseCategory(value, rowData.contractOrgId)}
            />
          ),
          lookup: arrayToLookup('contragentCategory', actualData),
          filterComponent: FilterMultiSelect,
      },
      {
          title: 'Сумма поступлений по договору, руб.',
          field: 'paymentOrderSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSum)),
      },
      {
          title: 'Сумма поступлений по договору, руб. (с учетом % уч.проекта)',
          field: 'paymentOrderSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentOrderSumWithShare)),
      },
      {
          title: 'Реквизиты платежных поручений',
          field: 'paymentOrdersField',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
      },
      {
          title: 'Сумма актов, руб.',
          field: 'paymentActSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSum)),
      },
      {
          title: 'Сумма актов, руб. (с учетом % уч.проекта)',
          field: 'paymentActSumWithShare',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.paymentActSumWithShare)),
      },
      {
          title: 'Реквизиты актов',
          field: 'paymentActsField',
          editable: 'never',
          filterCellStyle: { minWidth: '300px'},
          filtering: true,
      },
      {
          title: 'Сумма расходов по гранту, руб.',
          field: 'fbSum',
          editable: 'never',
          filterCellStyle: { minWidth: '227px'},
          filtering: true,
          render: (rowData) => renderNullFloatValues(Number(rowData.fbSum)),
      },
      {
        title: 'Полученный результат',
        field: 'result',
        filtering: false,
      },
      {
        title: 'Портфель',
        field: 'portfName',
        cellStyle: { minWidth: '230px'},
        lookup: arrayToLookup('portfName', actualData),
        filterComponent: FilterMultiSelect,
      },
    ]

  return [...getStickyColumns(colsLeft, 48), ...colsMiddle];
};
